import { useDispatch } from 'react-redux';
import { setDateOffset } from 'redux/reducers/meteorologyFieldsControlPanelReducer';

export default function useSliderProps(
  maxValue: number,
  minValue: number,
  dateOffset: number | undefined,
  period: string | undefined,
) {
  const dispatch = useDispatch();
  const isPentad = period ? period[0] === 'p' : false;

  if (isPentad) {
    const range = maxValue - minValue;
    const gap = Math.max(1, Math.ceil(range / 15));
    return {
      sliderClassName: 'pentad-slider',
      sliderMax: maxValue + gap,
      sliderMin: minValue,
      sliderValue: [dateOffset || 0, (dateOffset || 0) + gap],
      sliderMinDistance: gap,
      sliderOnChange: (value, index) => {
        const newDateOffset = index === 0
          ? value[0] : value[1] - gap;
        dispatch(setDateOffset(newDateOffset));
      },
    };
  }
  return {
    sliderClassName: 'horizontal-slider',
    sliderMax: maxValue,
    sliderMin: minValue,
    sliderValue: dateOffset,
    sliderOnChange: (value) => dispatch(setDateOffset(value)),
  };
}
